"use strict";
'kiwi public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  props: {
    links: {
      type: Object,
      default: () => ({})
    },
    /** 'welcome' | 'statebrowser' */
    variant: {
      type: String,
      default: 'welcome'
    }
  },
  computed: {
    layoutClass() {
      return this.variant === 'statebrowser' ? 'kiwi-social-links--statebrowser' : 'kiwi-social-links--welcome';
    },
    trimmed() {
      const L = this.links || {};
      const t = v => typeof v === 'string' ? v.trim() : '';
      return {
        instagram: t(L.instagram),
        twitter: t(L.twitter),
        facebook: t(L.facebook),
        tiktok: t(L.tiktok),
        telegram: t(L.telegram),
        reddit: t(L.reddit)
      };
    },
    hasLinks() {
      const s = this.trimmed;
      return !!(s.instagram || s.twitter || s.facebook || s.tiktok || s.telegram || s.reddit);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SocialLinks"]
window._kiwi_exports.components.SocialLinks = exports.default ? exports.default : exports;
